import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Raghav Menon </span>
            from <span className="purple"> Pune, India.</span>
            <br />
            I am currently a final-year student pursuing a B.Tech in Computer Science at
            <span className="purple"> SRM Institute of Science and Technology.</span>
            <br />
            <br />
            Apart from coding, I am passionate about data engineering and automation. 
            Some other activities that I love to do!
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Football ⚽
            </li>
            <li className="about-activity">
              <ImPointRight /> Designing AI/ML Models 🤖
            </li>
            <li className="about-activity">
              <ImPointRight /> Analyzing Stock Market Data 📈
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Data is the new oil, but only if you know how to refine it."{" "}
          </p>
          <footer className="blockquote-footer">Raghav</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;